import { defineStore } from 'pinia'
import { ref } from 'vue'

const useModel = defineStore('cabinet_admin_config_form', () => {
  const openForm = ref(false)

  /* Данные формы */
  const fields: {
    id: number | null
    pin_number: number | null
    device_event_type_id: number | null
    description: string
    value: number
  } = {
    id: null,
    pin_number: null,
    device_event_type_id: 4,
    description: '',
    value: -1,
  }

  const data = ref({ ...fields })

  /**
   * Функция очистки формы после закрытия
   */
  const closeForm = () => {
    openForm.value = false
    data.value = { ...fields }
  }

  return {
    openForm,
    data,
    fields,

    closeForm,
  }
})

export { useModel }
